import ReactGA from 'react-ga'

const TRACKING_ID = 'UA-87505721-2'

export const GAEvents = {
  APPLICATION_FLOW: 'myApplicationFlow',
  MP_TRANSACTIONS: 'mpTransactions',
  MP_STATISTICS: 'mpStatistics',
  MP_ADD_NEW_USER: 'mpAddNewUser',
  MP_CHAT_INTERACTION: 'mpChatInteraction',
  MP_LOGIN: 'mpLogin',
}

export const GACategories = {
  applicationFlow: {
    CALCULATOR: 'Application Flow - Calculator',
    APPLICATION_STEPS: 'Application Flow - Steps',
    PAYMENT_OPTIONS: 'Application Flow - Payment Options',
    PAYMENT_INFORMATION: 'Application Flow - Payment Details',
  },
  TRANSACTIONS: 'Transactions',
  STATISTICS: 'Statistics',
  ADD_NEW_USER: 'Add new user',
  CHAT_INTERACTION: 'Chat interaction',
  STORE_LOGIN: 'Store logged in',
}

export const GAActions = {
  CANCEL: 'Cancel',
  IMPRESSION: 'Impression',
  RESULTS: 'Results',
  PRESELECTED: 'Preselected',
  CHANGE: 'Change',
  CHANGE_FILTER: 'Change filter',
  INFORMATION: 'Information',
  SEARCH: 'Search',
  CHANGE_TRANSACTION: 'ChangeTransaction',
  SEND_PAYMENT_CONFIRMATION: 'Send payment confirmation',
  ADD_ROW: 'Add row',
  PAY_APPLY_STEP_1: 'Step 1 - Customer',
  PAY_APPLY_STEP_2: 'Step 2 - Payment',
  PAY_APPLY_STEP_2_1: 'Step 2 - Personal information',
  DEBIT_IN_MP: 'Debit the purchase in Merchant portal',
  PAY_APPLY_STEP_3: 'Step 3 - Legitimation / Sign',
  PAY_APPLY_STEP_4: 'Step 4 - Finished',
  CONFIRM_PAPER_SIGN: 'Confirmed paper signature',
  FILTER: 'filter',
  CHANGE_CHART: 'Change chart',
  ONE_USER: 'One user',
  MULTIPLE_USERS: 'Multiple users',
  START_CHAT: 'Start chat',
  LOGIN: 'Log in',
}

const createPayload = (event, action, category, data) => {
  let value
  let label
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(data)) {
    label = data
  } else {
    value = data
  }

  return {
    event,
    category,
    action,
    label,
    value,
  }
}

const init = () => {
  ReactGA.initialize(TRACKING_ID, { debug: false })
}

const sendEvent = (event, action, category, data, extra) => {
  if (extra) {
    ReactGA.set({ ...extra })
  }
  ReactGA.event(createPayload(event, action, category, data))
}

const sendPageview = path => {
  ReactGA.set({ page: path })
  ReactGA.pageview(path)
}

export default {
  init,
  sendEvent,
  sendPageview,
}
